import { render, staticRenderFns } from "./CompanyInfoReferrals.vue?vue&type=template&id=014291ed&scoped=true&"
import script from "./CompanyInfoReferrals.vue?vue&type=script&lang=ts&"
export * from "./CompanyInfoReferrals.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyInfoReferrals.vue?vue&type=style&index=0&id=014291ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014291ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('014291ed')) {
      api.createRecord('014291ed', component.options)
    } else {
      api.reload('014291ed', component.options)
    }
    module.hot.accept("./CompanyInfoReferrals.vue?vue&type=template&id=014291ed&scoped=true&", function () {
      api.rerender('014291ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanyInfoReferrals.vue"
export default component.exports